<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
// import Vuetable from "vuetable-2";
// import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Swal from "sweetalert2";
import Vue from "vue";
import moment from "moment";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";

// import DatePicker from "vue2-datepicker";
import Datepicker from "vuejs-datepicker";
import "vue-select/dist/vue-select.css";
import {  es } from "vuejs-datepicker/dist/locale";
// register the plugin on vue
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Toasted from "vue-toasted";
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Categoria component
 */
export default {
  page: {
    title: "Listado de reportes",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    datepicker: Datepicker,
    PageHeader,
    // Loader,
    // Vuetable,
    // VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
        es: es,
      repit_codigo: true,
      repit: true,
      fecha_inicio :'',
      
      disabledDates: {
          to: '',
      },
      fecha_fin :'',
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "lotes/get",
      arrayDetalle:[{
        nombre : 'Reporte de cerdos, (Gestación, Engorde, Destete, Otros...)',
        id:1,
      }, {
        id:2,
        nombre : 'Reporte de Ganancias de cerdos'
      }],
      cabezera: [
        { key: "nombre", label: "Nombre", thClass: "cell1" },
        { key: "fecha_inicio", label: "Fecha Inicio", thClass: "cell1" },
        { key: "fecha_fin", label: "Fecha Fin", thClass: "cell1" },
        { key: "Opciones", label: "Opciones", thClass: "cell1" },

      ],
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      arrTipoLote :[
        { nombre: 'Reemplazo' },
        { nombre: 'Gestacion' },
        { nombre: 'Lactancia' },
        { nombre: 'Destete' },
        { nombre: 'Cerdo De Engorde' },
        { nombre: 'Descarte'}
        
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      mask_quetzal: createNumberMask({
          prefix: "Q ",
          suffix: "",
          includeThousandsSeparator: true,
          thousandsSeparatorSymbol: ",",
          allowDecimal: true,
          decimalSymbol: ".",
          decimalLimit: 2, // how many digits allowed after the decimal
          integerLimit: 10, // limit length of integer numbers
          allowNegative: false,
          allowLeadingZeroes: false,
      }),
      formLote: {
        no_lote: "",
        fecha_inicio: "",
        tipo_lote: "",
        state: true,
        id: 0,
      },
      updating: false,
      estadotabla: true,
      title: "Listado de reportes",
      itemst: [
        {
          text: "Cerdos",
          href: "/",
        },
        {
          text: "Listado de reportes",
          active: true,
        },
      ],
      fields: [
        {
          name: "no_lote",
          title: "No. Lote",
          sortField: "no_lote",
          width: "20%",
        },
        {
          name: "no_animales",
          title: "No. Animales",
          sortField: "no_animales",
          width: "20%",
        },
        {
          name: "fecha_inicio",
          title: "Fecha inicio",
          sortField: "fecha_inicio",
          width: "20%",
        },
        {
          name: "tipo_lote",
          title: "Tipo Corral",
          sortField: "tipo_lote",
          width: "20%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
      ],
      searchType: [
        { nombre: "No. Lote", value: "no_lote" },
        { nombre: "Tipo Lote", value: "tipo_lote" }
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      banderaTipo:false,
      loadingtable: false,
      sortBy: "tipo_lote",
      sortDesc: false,
      searchLabel: { nombre: "No. Lote", value: "no_lote" },
      searchLabelLote: { nombre: "Gestacion", value: "Gestacion" },
      filterLabel: { nombre: "No. Lote", value: "no_lote" },
      showModalL: false,
      showModalN: false,
      showModalD: false,
      showModalA: false,
      showModalE: false,
      submitted: false,
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
    };
  },
  validations: {
    formLote: {
      no_lote: {
        required,
      },
      fecha_inicio: {
        required,
      },
      tipo_lote: {
        required,
      },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,

    //modal y validaciones
    limpiarModal() {
      this.formLote.nombre = "";
      this.formLote.id = 0;
    },
    validaciones(opc) {
      this.submitted = true;
      // console.log(this.repit)
      // stop here if form is invalid

      this.$v.$touch();
      // console.log(this.$v.$invalid, this.repit);
      if (this.$v.$invalid || this.repit_codigo == false) {
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
        if (opc == "update") {
          this.update();
        }
      }
    },
    //Desactivar registro
    desactivate() {
      const { id, no_lote } = this.formLote;
      axios
        .put(process.env.VUE_APP_URL + "lotes/desactivate", {
          id: id,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(no_lote + " Desactivado", this.options);
          const currentPage = this.$refs.vuetable.currentPage;
          
          this.$refs.vuetable.refresh(); 
          this.onChangePage(currentPage);
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },

    //ACtivar registro
    activate() {
      const { id, no_lote } = this.formLote;
      axios
        .put(process.env.VUE_APP_URL + "lotes/activate", {
          id: id,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          this.showModalA = false;
          Vue.toasted.info(no_lote + " Activado", this.options);
          const currentPage = this.$refs.vuetable.currentPage;
          
          this.$refs.vuetable.refresh(); 
          this.onChangePage(currentPage);
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para activar", this.options);
        });
    },
    convertMaskToNumber(value) {
      var myNumber = "";
      for (var i = 0; i < value.length; i += 1) {
        if (
          value.charAt(i) === "Q" ||
          value.charAt(i) === "," ||
          value.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += value.charAt(i);
        }
      } 
      return parseFloat(myNumber).toFixed(2);
    },
    //Guardar registro
    save() {
      const { no_lote,fecha_inicio, tipo_lote } = this.formLote;
      
      axios
        .post(process.env.VUE_APP_URL + "lotes/store", {
          no_lote: no_lote,
          fecha_inicio: fecha_inicio,
          tipo_lote: tipo_lote.nombre,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          Vue.toasted.success(no_lote + " Guardado", this.options);
          
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)
          this.showModalN = false;
          this.limpiarModal();
          this.submitted = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    //ACtualizar registro
    update() {
      const { no_lote, fecha_inicio, tipo_lote, id  } = this.formLote;

      axios
        .put(process.env.VUE_APP_URL + "lotes/update", {
          id: id,
          no_lote: no_lote,
          fecha_inicio: fecha_inicio,
          tipo_lote: tipo_lote.nombre,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          Vue.toasted.success(no_lote + " Actualizado", this.options);
          
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)

          this.showModalE = false;
          this.limpiarModal();
          this.submitted = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },

    //Timer de registro guardado para notificacion
    timer() {
      let timerInterval;
      Swal.fire({
        title: "Auto close alert!",
        html: "I will close in <b></b> milliseconds.",
        timer: 2000,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(() => {
            Swal.getContent().querySelector("b").textContent =
              Swal.getTimerLeft();
          }, 100);
        },
        onClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log("I was closed by the timer"); // eslint-disable-line
        }
      });
    },
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      console.log(paginationData);
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
     
        this.banderaTipo =  type.value == "tipo_lote" ? true : false;
      this.$refs.vuetable.refresh();
    },
    changeTypeSearchLote(type) {
      this.searchLabelLote = type;
      
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            tipo_lote : this.banderaTipo == true ? this.searchLabelLote.nombre : "",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            tipo_lote : this.banderaTipo == true ? this.searchLabelLote.nombre : "",
            limite: this.perPage,
            search: this.search,
          };
    },
    async handleAction(item) {
        console.log(item);
    if (item.nombre === 'Reporte de Ganancias de cerdos') {
      this.generarReporteGanancias();
    } else if (item.nombre === 'Reporte de cerdos, (Gestación, Engorde, Destete, Otros...)') {
      await this.reporteCerdos();
    } else {
      console.warn('No se definió una acción para este registro:', item);
    }
  },
  async generarReporteGanancias(){
    this.showModalL= true;
    const urlas = process.env.VUE_APP_URL + "venta_cerdos/get_totales?fecha_inicio=" + this.customFormatter(this.fecha_inicio) + "&fecha_fin=" + this.customFormatter(this.fecha_fin);
          
          const response = await axios({
          url: urlas, 
        
          headers: { "x-token": this.userT.token },
        
          method: 'GET',
          responseType: 'blob', // Importante para recibir el PDF como un Blob binario
          });
          // Crear un enlace temporal para forzar la descarga
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'reporte_ganancias.pdf'); // Nombre del archivo de descarga
          document.body.appendChild(link);
          link.click(); // Forzar el clic para descargar
          // Eliminar el enlace temporal
          document.body.removeChild(link);
          this.showModalL= false;
  },
    async reporteCerdos() {
      this.showModalL= true;
        const urlas = process.env.VUE_APP_URL + 'cerdos/cerdo_report';
                
                const response = await axios({
                url: urlas, 
              
                headers: { "x-token": this.userT.token },
              
                method: 'GET',
                responseType: 'blob', // Importante para recibir el PDF como un Blob binario
                });

                // Crear un enlace temporal para forzar la descarga
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'reporte_cerdos.pdf'); // Nombre del archivo de descarga
                document.body.appendChild(link);
                link.click(); // Forzar el clic para descargar

                // Eliminar el enlace temporal
                document.body.removeChild(link);

                this.showModalL= false;
    },
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    formatoPresentacion(date) {
      return moment(date).locale("es").format("LL");
    // return moment(date).locale("es").format("LLLL");
    },
    //Para abrir los modales y pasar los datos de la fila
    onActionClicked(action, data) {
      if (action == "edit-item") {
        this.formLote.no_lote = data.no_lote;
        this.formLote.fecha_inicio = data.fecha_inicio;
        this.formLote.tipo_lote = data.tipo_lote;
        this.formLote.id = data.id;
        this.showModalE = true;
      }
      if (action == "new-item") {
        this.formLote.no_lote = "";
        this.formLote.tipo_lote = "";
        this.formLote.fecha_inicio = "";
        this.showModalN = true;
      }
      if (action == "desactivate-item") {
        this.formLote.no_lote = data.no_lote;
        this.formLote.id = data.id;
        this.showModalD = true;
      }
      if (action == "activate-item") {
        this.formLote.no_lote = data.no_lote;
        this.formLote.id = data.id;
        this.showModalA = true;
      }
    },
    updateDisableDates(){
      let me = this;
      if(new Date(me.customFormatter(me.fecha_inicio)).getTime() > new Date(me.customFormatter(me.fecha_fin))){
          me.$refs.myDatepicker.clearDate();
          me.fecha_fin = '';
      }
      me.disabledDates.to = new Date(me.fecha_inicio);
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style scoped>
.table-responsive {
  min-height: 300px; /* Asegura suficiente espacio para mostrar el calendario */
}
.datepicker {
  z-index: 1050; /* Asegurar que el calendario esté encima de otros elementos */
}

</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Reportes</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  
                </div>
              </div>

              <div class="col-sm-12 col-md-2">
                <div
                  id="tickets-table_length"
                  class="dataTables_length text-md-end"
                >

                </div>
              </div>



              <!-- End search -->
            </div>
            <!-- Table -->
            <div style="overflow-x: auto;">

            <b-table
                    small
                    striped
                    responsive
                    v-if="arrayDetalle.length > 0"
                    ref="table"
                    class="table-divided order-with-arrow"
                    :items="arrayDetalle"
                    :fields="cabezera"
                    >
                    <template #cell(nombre)="data">
                        {{ data.item.nombre }}
                    </template>
                    <template #cell(fecha_inicio)="data">
                      <div class="fecha-container">
                        <datepicker 
                        class="datepicker-wrapper"
                        v-if="data.item.id === 2"
                        :bootstrap-styling="true"
                        @input="updateDisableDates()" 
                        placeholder="Fecha inicio" 
                        :language="es" 
                        :format="customFormatter" 
                         :append-to-body="true"
                        v-model="fecha_inicio" 
                        ></datepicker>
                        </div>  
                    </template>
                    <template #cell(fecha_fin)="data">
                      <div class="fecha-container">
                        <datepicker :bootstrap-styling="true"  class="datepicker-wrapper" v-if="data.item.id === 2"  ref="myDatepicker" 
                  placeholder="Fecha fin" :disabledDates="disabledDates" :language="es" :format="customFormatter" v-model="fecha_fin"></datepicker>
                        </div>
                    </template>
                    <template #cell(opciones)="data">
                        <b-button-group class="mt-4 mt-md-0">
                        <b-button
                            tabindex="0"
                            v-b-tooltip.focus
                            title="Agregar"
                            variant="outline-primary"
                            @click="handleAction(data.item)" 
                        >
                            <i class="bx bx-check"></i>
                        </b-button>
    </b-button-group>
  </template>
</b-table>
</div>  
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.fecha-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.b-button {
  padding: 5px 10px;
  font-size: 0.8rem;
}

.b-button-group {
  justify-content: flex-end;
}

.b-table th,
.b-table td {
  padding: 10px 15px;
  text-align: center;
  white-space: nowrap;
  font-size: 0.9rem;
}

.b-table tr:hover {
  background-color: #f9f9f9;
}

.b-button {
  margin: 0 auto;
}.b-table td {
  white-space: normal; /* Permite saltos de línea */
  word-wrap: break-word; /* Ajusta palabras largas */
}
.datepicker-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Contenedor de la tabla */
.card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px 0;
}.datepicker {
  width: 100%;
  max-width: 120px;
  text-align: center;
  padding: 6px;
  font-size: 0.85rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}


.card-title {
  font-size: 1.8rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

/* Tabla */
.b-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.b-table th {
  background-color: #f0f0f0;
  text-align: center;
  font-weight: bold;
  padding: 10px;
  border-bottom: 2px solid #ddd;
  font-size: 1rem;
}

.b-table td {
  text-align: center;
  padding: 15px 10px;
  border-bottom: 1px solid #eee;
  font-size: 0.95rem;
}

.b-table tr:hover {
  background-color: #f9f9f9;
}

/* Ajustes responsivos */
.datepicker {
  width: 100%;
  max-width: 140px;
  margin: auto;
  padding: 8px;
  font-size: 0.9rem;
  border-radius: 5px;
  border: 1px solid #ddd;
}

/* Botones */
.b-button-group {
  display: flex;
  justify-content: center;
}

.b-button {
  padding: 8px 15px;
  border-radius: 8px;
  font-size: 0.9rem;
  background-color: #4c6ef5;
  color: white;
  border: none;
  transition: all 0.3s ease;
}

.b-button:hover {
  background-color: #3b5bdb;
  transform: scale(1.05);
}

/* Espaciado para pantallas pequeñas */
@media (max-width: 768px) {
  .b-table {
    display: block;
    overflow-x: auto;
  }

  .b-table th,
  .b-table td {
    padding: 10px;
    font-size: 0.85rem;
  }

  .datepicker {
    font-size: 0.85rem;
    padding: 7px;
  }

  .b-button {
    font-size: 0.85rem;
    padding: 6px 12px;
  }
}

/* Pantallas muy pequeñas */
@media (max-width: 576px) {
  .card-title {
    font-size: 1.5rem;
  }

  .b-table th,
  .b-table td {
    font-size: 0.8rem;
    padding: 8px;
  }

  .b-button {
    font-size: 0.8rem;
    padding: 5px 10px;
  }
  .b-table th,
.b-table td {
  padding: 12px 20px;
}
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.b-table th:nth-child(1),
.b-table td:nth-child(1) {
  min-width: 200px; /* Ajusta según el contenido */
}
.b-table th:nth-child(3),
.b-table td:nth-child(3) {
  min-width: 100px; /* Fechas */
}
.b-table td {
  vertical-align: middle;
}

  .datepicker {
    font-size: 0.8rem;
    padding: 6px;
  }
}@media (max-width: 768px) {
  .b-table th,
  .b-table td {
    font-size: 0.85rem;
    padding: 8px;
  }

  .datepicker {
    max-width: 100px; /* Ajustar ancho del selector de fechas */
  }
}

</style>
